import React, { useEffect, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';

import StarsWidget from '@swf/components/StarsWidget/StarsWidget';
import type { Dispatch, Store } from '@swf/core/store';
import type { StaticContext } from '@swf/core/types/StaticContext';

export const footerWidgetProps = {
  type: 'FooterWidget' as const,
  id: 'footerWidget/114d96fc',
  config: {},
  services: { cms: { config: { name: 'cms.footer', onLoad: true } } },
  meta: { name: 'Footter Widget' }
};

const FirstCMSFooter: React.FC = () => {
  const staticContext: StaticContext = {};
  const dispatch = useDispatch<Dispatch>();
  const [footerPreloaded, setFooterPreloaded] = useState(!!dispatch[footerWidgetProps.id]);
  const store = useStore() as Store;

  staticContext.prefetch = async ({ dispatch }, version) => {
    (staticContext.prefetch?.(store, version) || Promise.resolve()).then(async () => {
      await Promise.all([
        await dispatch.page.prepareWidget(footerWidgetProps),
        await dispatch.page.loadWidget(footerWidgetProps)
      ]);
    });
  };

  useEffect(() => {
    const fetchFooterData = async () => {
      await Promise.all([
        await dispatch.page.prepareWidget(footerWidgetProps),
        await dispatch.page.loadWidget(footerWidgetProps)
      ]);
    };

    if (!footerPreloaded) {
      fetchFooterData().then(() => setFooterPreloaded(true));
    }
  }, [dispatch.page, footerPreloaded]);

  return footerPreloaded ? <StarsWidget {...footerWidgetProps} /> : null;
};

export default FirstCMSFooter;
